export default __webpack_public_path__ + "static/media/icon-email.47056cef.svg";